"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const subscribable_1 = __importDefault(require("./subscribable"));
const util_1 = require("../services/util");
class AssetGod extends subscribable_1.default {
    constructor(dataService, initParams) {
        super(dataService, initParams.id);
        this.gateway = null;
        this.objectTypeName = 'assetGod';
        this._lastContacted = initParams.last_contacted;
        this._name = initParams.name;
        this._siteName = initParams.site_name;
        this._siteId = initParams.site_id;
        this._siteTimezone = initParams.site_timezone;
        this._impKwh = initParams.imp_kwh;
        this._parentAsset = initParams.parent_asset;
        this._currentState = initParams.current_state;
        this._userState = initParams.user_state;
        this._sku = initParams.sku;
        this._code = initParams.code;
        this._dataType = initParams.data_type;
        this._generation = initParams.generation;
        this._assetIndex = initParams.asset_index;
        this._ble = initParams.ble;
        this._boostFinish = initParams.boost_finish;
        this._snoozeFinish = initParams.snooze_finish;
        this._gatewayId = initParams.gateway_id;
        this._gatewayName = initParams.gateway_name;
        this._applianceType = initParams.appliance_type;
        this.__permission = initParams._permission;
        this._serialNo = initParams.serial_no;
        this._readOnly = initParams.read_only;
        this._locked = initParams.locked;
        this._children = (0, util_1.camelArray)(initParams.children);
        this._disconnected = initParams.disconnected;
        this._gatewayDisconnected = initParams.gateway_disconnected;
        this._clampNameTwo = initParams.clamp_name_two;
        this._clampSize = initParams.clamp_size;
        this._climaxClamp = initParams.climax_clamp;
        this._triggerRules = (0, util_1.camelArray)(initParams.trigger_rules);
        this._alertRules = (0, util_1.camelArray)(initParams.alert_rules);
        this._advancedRules = (0, util_1.camelArray)(initParams.advanced_rules);
        this._consumption = initParams.consumption;
        this._consumptionPulse = initParams.consumption_pulse;
        this._gasPulse = initParams.gas_pulse;
        this._waterPulse = initParams.water_pulse;
        this._waterPulseHot = initParams.water_pulse_hot;
        this._temperature = initParams.temperature;
        this._humidity = initParams.humidity;
        this._light = initParams.light;
        this._occupancy = initParams.occupancy;
        this._assetSignalStrength = initParams.asset_signal_strength;
        this._assetBatteryVoltage = initParams.asset_battery_voltage;
        this._assetBatteryAlarm = initParams.asset_battery_alarm;
        this._assetBatteryPercent = initParams.asset_battery_percent;
        this._firmwareTarget = initParams.firmware_target;
        this._assetFirmwareVersion = initParams.asset_firmware_version;
        this._assetFirmwareProgress = initParams.asset_firmware_progress;
        this._demandPhaseOne = initParams.demand_phase_one;
        this._demandPhaseTwo = initParams.demand_phase_two;
        this._demandPhaseThree = initParams.demand_phase_three;
        this._nbIotEcl = initParams.nb_iot_ecl;
        this._doReconfigure = initParams.do_reconfigure;
    }
    set lastContacted(value) {
        console.error('Do not set objects this way');
    }
    setLastContacted(value) {
        return this.dataService.updateAssetGod(this.id, { last_contacted: value }, this);
    }
    get lastContacted() {
        return this._lastContacted;
    }
    set name(value) {
        console.error('Do not set objects this way');
    }
    setName(value) {
        return this.dataService.updateAssetGod(this.id, { name: value }, this);
    }
    get name() {
        return this._name;
    }
    set siteName(value) {
        console.error('Do not set objects this way');
    }
    setSiteName(value) {
        return this.dataService.updateAssetGod(this.id, { site_name: value }, this);
    }
    get siteName() {
        return this._siteName;
    }
    set siteId(value) {
        console.error('Do not set objects this way');
    }
    setSiteId(value) {
        return this.dataService.updateAssetGod(this.id, { site_id: value }, this);
    }
    get siteId() {
        return this._siteId;
    }
    set siteTimezone(value) {
        console.error('Do not set objects this way');
    }
    setSiteTimezone(value) {
        return this.dataService.updateAssetGod(this.id, { site_timezone: value }, this);
    }
    get siteTimezone() {
        return this._siteTimezone;
    }
    set impKwh(value) {
        console.error('Do not set objects this way');
    }
    setImpKwh(value) {
        return this.dataService.updateAssetGod(this.id, { imp_kwh: value }, this);
    }
    get impKwh() {
        return this._impKwh;
    }
    set parentAsset(value) {
        console.error('Do not set objects this way');
    }
    setParentAsset(value) {
        return this.dataService.updateAssetGod(this.id, { parent_asset: value }, this);
    }
    get parentAsset() {
        return this._parentAsset;
    }
    set currentState(value) {
        console.error('Do not set objects this way');
    }
    setCurrentState(value) {
        return this.dataService.updateAssetGod(this.id, { current_state: value }, this);
    }
    get currentState() {
        return this._currentState;
    }
    set userState(value) {
        console.error('Do not set objects this way');
    }
    setUserState(value) {
        return this.dataService.updateAssetGod(this.id, { user_state: value }, this);
    }
    get userState() {
        return this._userState;
    }
    set sku(value) {
        console.error('Do not set objects this way');
    }
    setSku(value) {
        return this.dataService.updateAssetGod(this.id, { sku: value }, this);
    }
    get sku() {
        return this._sku;
    }
    set code(value) {
        console.error('Do not set objects this way');
    }
    setCode(value) {
        return this.dataService.updateAssetGod(this.id, { code: value }, this);
    }
    get code() {
        return this._code;
    }
    set dataType(value) {
        console.error('Do not set objects this way');
    }
    setDataType(value) {
        return this.dataService.updateAssetGod(this.id, { data_type: value }, this);
    }
    get dataType() {
        return this._dataType;
    }
    set generation(value) {
        console.error('Do not set objects this way');
    }
    setGeneration(value) {
        return this.dataService.updateAssetGod(this.id, { generation: value }, this);
    }
    get generation() {
        return this._generation;
    }
    set assetIndex(value) {
        console.error('Do not set objects this way');
    }
    setAssetIndex(value) {
        return this.dataService.updateAssetGod(this.id, { asset_index: value }, this);
    }
    get assetIndex() {
        return this._assetIndex;
    }
    set ble(value) {
        console.error('Do not set objects this way');
    }
    setBle(value) {
        return this.dataService.updateAssetGod(this.id, { ble: value }, this);
    }
    get ble() {
        return this._ble;
    }
    set boostFinish(value) {
        console.error('Do not set objects this way');
    }
    setBoostFinish(value) {
        return this.dataService.updateAssetGod(this.id, { boost_finish: value }, this);
    }
    get boostFinish() {
        return this._boostFinish;
    }
    set snoozeFinish(value) {
        console.error('Do not set objects this way');
    }
    setSnoozeFinish(value) {
        return this.dataService.updateAssetGod(this.id, { snooze_finish: value }, this);
    }
    get snoozeFinish() {
        return this._snoozeFinish;
    }
    set gatewayId(value) {
        console.error('Do not set objects this way');
    }
    setGatewayId(value) {
        return this.dataService.updateAssetGod(this.id, { gateway_id: value }, this);
    }
    get gatewayId() {
        return this._gatewayId;
    }
    set gatewayName(value) {
        console.error('Do not set objects this way');
    }
    setGatewayName(value) {
        return this.dataService.updateAssetGod(this.id, { gateway_name: value }, this);
    }
    get gatewayName() {
        return this._gatewayName;
    }
    set applianceType(value) {
        console.error('Do not set objects this way');
    }
    setApplianceType(value) {
        return this.dataService.updateAssetGod(this.id, { appliance_type: value }, this);
    }
    get applianceType() {
        return this._applianceType;
    }
    set _permission(value) {
        console.error('Do not set objects this way');
    }
    set_permission(value) {
        return this.dataService.updateAssetGod(this.id, { _permission: value }, this);
    }
    get _permission() {
        return this.__permission;
    }
    set serialNo(value) {
        console.error('Do not set objects this way');
    }
    setSerialNo(value) {
        return this.dataService.updateAssetGod(this.id, { serial_no: value }, this);
    }
    get serialNo() {
        return this._serialNo;
    }
    set readOnly(value) {
        console.error('Do not set objects this way');
    }
    setReadOnly(value) {
        return this.dataService.updateAssetGod(this.id, { read_only: value }, this);
    }
    get readOnly() {
        return this._readOnly;
    }
    set locked(value) {
        console.error('Do not set objects this way');
    }
    setLocked(value) {
        return this.dataService.updateAssetGod(this.id, { locked: value }, this);
    }
    get locked() {
        return this._locked;
    }
    set children(value) {
        console.error('Do not set objects this way');
    }
    setChildren(value) {
        return this.dataService.updateAssetGod(this.id, { children: (0, util_1.snakeArray)(value) }, this);
    }
    get children() {
        return this._children;
    }
    set disconnected(value) {
        console.error('Do not set objects this way');
    }
    setDisconnected(value) {
        return this.dataService.updateAssetGod(this.id, { disconnected: value }, this);
    }
    get disconnected() {
        return this._disconnected;
    }
    set gatewayDisconnected(value) {
        console.error('Do not set objects this way');
    }
    setGatewayDisconnected(value) {
        return this.dataService.updateAssetGod(this.id, { gateway_disconnected: value }, this);
    }
    get gatewayDisconnected() {
        return this._gatewayDisconnected;
    }
    set clampNameTwo(value) {
        console.error('Do not set objects this way');
    }
    setClampNameTwo(value) {
        return this.dataService.updateAssetGod(this.id, { clamp_name_two: value }, this);
    }
    get clampNameTwo() {
        return this._clampNameTwo;
    }
    set clampSize(value) {
        console.error('Do not set objects this way');
    }
    setClampSize(value) {
        return this.dataService.updateAssetGod(this.id, { clamp_size: value }, this);
    }
    get clampSize() {
        return this._clampSize;
    }
    set climaxClamp(value) {
        console.error('Do not set objects this way');
    }
    setClimaxClamp(value) {
        return this.dataService.updateAssetGod(this.id, { climax_clamp: value }, this);
    }
    get climaxClamp() {
        return this._climaxClamp;
    }
    set triggerRules(value) {
        console.error('Do not set objects this way');
    }
    setTriggerRules(value) {
        return this.dataService.updateAssetGod(this.id, { trigger_rules: (0, util_1.snakeArray)(value) }, this);
    }
    get triggerRules() {
        return this._triggerRules;
    }
    set alertRules(value) {
        console.error('Do not set objects this way');
    }
    setAlertRules(value) {
        return this.dataService.updateAssetGod(this.id, { alert_rules: (0, util_1.snakeArray)(value) }, this);
    }
    get alertRules() {
        return this._alertRules;
    }
    set advancedRules(value) {
        console.error('Do not set objects this way');
    }
    setAdvancedRules(value) {
        return this.dataService.updateAssetGod(this.id, { advanced_rules: (0, util_1.snakeArray)(value) }, this);
    }
    get advancedRules() {
        return this._advancedRules;
    }
    set consumption(value) {
        console.error('Do not set objects this way');
    }
    setConsumption(value) {
        return this.dataService.updateAssetGod(this.id, { consumption: value }, this);
    }
    get consumption() {
        return this._consumption;
    }
    set consumptionPulse(value) {
        console.error('Do not set objects this way');
    }
    setConsumptionPulse(value) {
        return this.dataService.updateAssetGod(this.id, { consumption_pulse: value }, this);
    }
    get consumptionPulse() {
        return this._consumptionPulse;
    }
    set gasPulse(value) {
        console.error('Do not set objects this way');
    }
    setGasPulse(value) {
        return this.dataService.updateAssetGod(this.id, { gas_pulse: value }, this);
    }
    get gasPulse() {
        return this._gasPulse;
    }
    set waterPulse(value) {
        console.error('Do not set objects this way');
    }
    setWaterPulse(value) {
        return this.dataService.updateAssetGod(this.id, { water_pulse: value }, this);
    }
    get waterPulse() {
        return this._waterPulse;
    }
    set waterPulseHot(value) {
        console.error('Do not set objects this way');
    }
    setWaterPulseHot(value) {
        return this.dataService.updateAssetGod(this.id, { water_pulse_hot: value }, this);
    }
    get waterPulseHot() {
        return this._waterPulseHot;
    }
    set temperature(value) {
        console.error('Do not set objects this way');
    }
    setTemperature(value) {
        return this.dataService.updateAssetGod(this.id, { temperature: value }, this);
    }
    get temperature() {
        return this._temperature;
    }
    set humidity(value) {
        console.error('Do not set objects this way');
    }
    setHumidity(value) {
        return this.dataService.updateAssetGod(this.id, { humidity: value }, this);
    }
    get humidity() {
        return this._humidity;
    }
    set light(value) {
        console.error('Do not set objects this way');
    }
    setLight(value) {
        return this.dataService.updateAssetGod(this.id, { light: value }, this);
    }
    get light() {
        return this._light;
    }
    set occupancy(value) {
        console.error('Do not set objects this way');
    }
    setOccupancy(value) {
        return this.dataService.updateAssetGod(this.id, { occupancy: value }, this);
    }
    get occupancy() {
        return this._occupancy;
    }
    set assetSignalStrength(value) {
        console.error('Do not set objects this way');
    }
    setAssetSignalStrength(value) {
        return this.dataService.updateAssetGod(this.id, { asset_signal_strength: value }, this);
    }
    get assetSignalStrength() {
        return this._assetSignalStrength;
    }
    set assetBatteryVoltage(value) {
        console.error('Do not set objects this way');
    }
    setAssetBatteryVoltage(value) {
        return this.dataService.updateAssetGod(this.id, { asset_battery_voltage: value }, this);
    }
    get assetBatteryVoltage() {
        return this._assetBatteryVoltage;
    }
    set assetBatteryAlarm(value) {
        console.error('Do not set objects this way');
    }
    setAssetBatteryAlarm(value) {
        return this.dataService.updateAssetGod(this.id, { asset_battery_alarm: value }, this);
    }
    get assetBatteryAlarm() {
        return this._assetBatteryAlarm;
    }
    set assetBatteryPercent(value) {
        console.error('Do not set objects this way');
    }
    setAssetBatteryPercent(value) {
        return this.dataService.updateAssetGod(this.id, { asset_battery_percent: value }, this);
    }
    get assetBatteryPercent() {
        return this._assetBatteryPercent;
    }
    set firmwareTarget(value) {
        console.error('Do not set objects this way');
    }
    setFirmwareTarget(value) {
        return this.dataService.updateAssetGod(this.id, { firmware_target: value }, this);
    }
    get firmwareTarget() {
        return this._firmwareTarget;
    }
    set assetFirmwareVersion(value) {
        console.error('Do not set objects this way');
    }
    setAssetFirmwareVersion(value) {
        return this.dataService.updateAssetGod(this.id, { asset_firmware_version: value }, this);
    }
    get assetFirmwareVersion() {
        return this._assetFirmwareVersion;
    }
    set assetFirmwareProgress(value) {
        console.error('Do not set objects this way');
    }
    setAssetFirmwareProgress(value) {
        return this.dataService.updateAssetGod(this.id, { asset_firmware_progress: value }, this);
    }
    get assetFirmwareProgress() {
        return this._assetFirmwareProgress;
    }
    set demandPhaseOne(value) {
        console.error('Do not set objects this way');
    }
    setDemandPhaseOne(value) {
        return this.dataService.updateAssetGod(this.id, { demand_phase_one: value }, this);
    }
    get demandPhaseOne() {
        return this._demandPhaseOne;
    }
    set demandPhaseTwo(value) {
        console.error('Do not set objects this way');
    }
    setDemandPhaseTwo(value) {
        return this.dataService.updateAssetGod(this.id, { demand_phase_two: value }, this);
    }
    get demandPhaseTwo() {
        return this._demandPhaseTwo;
    }
    set demandPhaseThree(value) {
        console.error('Do not set objects this way');
    }
    setDemandPhaseThree(value) {
        return this.dataService.updateAssetGod(this.id, { demand_phase_three: value }, this);
    }
    get demandPhaseThree() {
        return this._demandPhaseThree;
    }
    set nbIotEcl(value) {
        console.error('Do not set objects this way');
    }
    setNbIotEcl(value) {
        return this.dataService.updateAssetGod(this.id, { nb_iot_ecl: value }, this);
    }
    get nbIotEcl() {
        return this._nbIotEcl;
    }
    set doReconfigure(value) {
        console.error('Do not set objects this way');
    }
    setDoReconfigure(value) {
        return this.dataService.updateAssetGod(this.id, { do_reconfigure: value }, this);
    }
    get doReconfigure() {
        return this._doReconfigure;
    }
    set(object) {
        let updateObject = (0, util_1.snakeObject)(object);
        let self = this;
        return this.dataService.updateAssetGod(this.id, updateObject, this)
            .then(function (res) {
            Object.keys(object).forEach(function (key) {
                self['_' + key] = object[key];
            });
            return Promise.resolve(res);
        });
    }
    delete() {
        return this.dataService.deleteAssetGod(this.id, this);
    }
}
exports.default = AssetGod;
//# sourceMappingURL=assetGod.js.map